import { calcAll, calcSingle } from './calcAll.js';
import prototypeFormulas from './prototypeFormulas.js';
import collectTags from './collectTags.js';
import operations from './Operations.js';
import groups from './groups.js';
import setEditable from './setEditable.js';
import mergeParents from './mergeParents.js';
import DicePool from './DicePool/DicePool.js';
import Tnl from './Tnl.js';

// TODO: Fix `calcSingle` for optimization.
// When overrideSingleEntity is false, new entities do not immediately trigger a save and refresh.
function calculateAllXp (doc, editable = false, oldDoc = null, overrideSingleEntity = true) {
    // console.log('\n\n\n<<<<<<<<<<<<<<<\ncalculateAllXp', doc.entities.length)
    if(!doc) {
        console.error("NO DOC!")
        return null;
    }
    // this system for overriding only a single entity is not finished or is broken.
    // it needs to allow for initial loads of the save file.
    // if(overrideSingleEntity && doc.activeEntity && !!oldDoc && oldDoc != {}) {
    //     console.log('calc single', doc.entities.length)
    //     // console.log("Update Single Entity");
    //     var newDoc = doc;
    //     doc = calcSingle(oldDoc, newDoc);
    //     collectTags(doc);
    //     setEditable(doc, editable);
    // }
    // else {
    //     console.log('calc all but merge firs', doc.entities.length)
    //     mergeParents(doc, doc);
    //     // console.log("update entire doc");
    //     doc = prototypeFormulas(doc);
    //     doc = calcAll(doc);
    //     // console.log(doc.total);
    //     collectTags(doc);
    //     setEditable(doc, editable);
    // }
    
    // console.log('calc all but merge firs', doc.entities.length)
    // console.log('doc.dependencies', doc.dependencies)
    mergeParents(doc, doc);
    // console.log("update entire doc");
    doc = prototypeFormulas(doc);
    doc = calcAll(doc);
    // console.log(doc.total);
    collectTags(doc);
    setEditable(doc, editable);
    
    // console.log('calculateAllXp', doc.entities.length)
    return doc;
}

export const Sgs = {
    calculateAllXp,
    operations,
    groups,
    DicePool,
    Tnl,
}

// ESM
export default Sgs;